import {message} from 'antd';
import {queryIncuBaseInfo} from '@api/incubator/base';
import PageAdd from './PageAdd';

class Edit extends PageAdd {
  componentWillMount() {
    const { uuid } = this.props.routeParams;
    this.loadData(uuid);
  }

  loadData = uuid => {
    queryIncuBaseInfo({ uuid }).then(res => {
      if (res.statusCode === 200) {
        const { dataInfo } = this.state;
        this.setState({
          dataInfo: {
            ...dataInfo,
            ...res.data,
          },
        });
      } else {
        message.error(res.message);
      }
    });
  };

  // loadStationCount = (uuid) => {
  // 	StationApi.getIncuStationCount({incubatorUuid: uuid}).then(res=>{
  // 		if (res.statusCode === 200) {
  // 			this.setState({
  // 				dataInfo: {
  // 					...this.state.dataInfo,
  // 					stationCount: res.data.count,
  // 				}
  // 			})
  // 		} else {
  // 			message.error(res.message)
  // 		}
  // 	})
  // }

  // loadAddressCount = (uuid) => {
  // 	AddressApi.getIncuAddressCount({incubatorUuid: uuid}).then(res=>{
  // 		if (res.statusCode === 200) {
  // 			this.setState({
  // 				dataInfo: {
  // 					...this.state.dataInfo,
  // 					addressCount: res.data.count,
  // 				}
  // 			})
  // 		} else {
  // 			message.error(res.message)
  // 		}
  // 	})
  // }
}

export default Edit;



// WEBPACK FOOTER //
// ./src/components/incubator/base/PageEdit.js